function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.37 15.22L12.19 18a2.34 2.34 0 003.3 0L18 15.49a2.34 2.34 0 000-3.3l-2.77-2.82",
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.84 19.64a3.24 3.24 0 01-2.29-.95l-2.82-2.82A.91.91 0 0110 14.58l2.82 2.82a1.43 1.43 0 002 0l2.55-2.55a1.43 1.43 0 000-2L14.58 10a.91.91 0 011.29-1.29l2.82 2.82a3.25 3.25 0 010 4.59l-2.55 2.55a3.24 3.24 0 01-2.3.97z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.69 5.83L7.45 1.59a2.34 2.34 0 00-3.3 0L1.59 4.14a2.34 2.34 0 000 3.3l4.24 4.24",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.84 12.6a.91.91 0 01-.64-.27L1 8.09A3.24 3.24 0 011 3.5L3.5.95a3.25 3.25 0 014.59 0l4.24 4.24a.91.91 0 01-1.29 1.29L6.81 2.23a1.43 1.43 0 00-2 0L2.24 4.79a1.43 1.43 0 000 2L6.48 11a.91.91 0 01-.64 1.55zM14.7 6.3a.45.45 0 01-.32-.77l2-2a.45.45 0 01.65.64l-2 2a.45.45 0 01-.33.13zM16.7 8.29a.45.45 0 010-.91h2.85a.45.45 0 010 .91H16.7zM12.7 4.3h-.09a.45.45 0 01-.36-.54L12.83.9a.45.45 0 11.89.18l-.57 2.85a.45.45 0 01-.45.37zM3.81 17.15a.45.45 0 01-.32-.78l2-2a.45.45 0 11.64.65l-2 2a.45.45 0 01-.32.13zM7.81 20a.45.45 0 01-.45-.46v-2.85a.45.45 0 01.45-.45.45.45 0 01.45.46v2.85a.45.45 0 01-.45.45zM4.45 13.16L1 13.12a.45.45 0 010-.91h3.45a.45.45 0 010 .91z",
  fill: "#231f20"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgComponent;